import { useEffect, useRef, useState } from 'react';
import { Expandable2 } from '../../../../components/Expandable/Expandable2';
import Input from '../../../../components/Inputs/Input';
import Item from '../../../../components/Lists/Item';
import { Radios } from '../../../../components/RadioGroup/Radios';
import { Tag } from '../../../../components/Tags/Tag';
import './Effectivity.css';
import Checkbox from '../../../../components/Checkbox/Checkbox';
import { useDropdownConfig } from '../../../../contexts/DropdownsContext';
import Dropdowns from '../../../../components/Dropdowns/Dropdowns';
import { useDispatch, useSelector } from 'react-redux';
import { addEffectivity, addRange, applyRanges, deleteEff, fetchAircrafts, fetchEffectivities, fetchAcSelection, saveEffectivity, selectACLine, selectACSerial, selectAircrafts, selectEditingEff, selectEff, selectEffList, selectRanges, startEdition, udpateAcSelection, updateEffectivity, updateRange, selectAll } from '../../../../redux/features/configuration/parts/effectivitySlice';
import MultioptionButton from '../../../../components/Buttons/MultioptionButton';
import { HTTP_RESPONSE_CODES, LABELS } from '../../../../globals/globals';
import { EffRange } from './EffRange';
import useDebounce from '../../../../hooks/useDebounce';
import { DialogTrigger } from '../../../../components/Dialog/Dialog';
import DeletePartDialog from './DeletePartDialog';
import { useSnackBar } from '../../../../hooks/useSnackBar';
import { useAlert } from '../../../../hooks/useAlert';


const NewButton = ({ partId }) => {
    const dispatch = useDispatch();


    return (
        <button className='outlined icon small-size' onClick={() => { dispatch(addEffectivity({ partId })) }}>
            <i className='icon-add-new'></i>
        </button>
    )
}

export const Effectivity = ({ part }) => {

    const effList = useSelector(selectEffList);
    const effListRef = useRef(null);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchEffectivities({ partId: part.id }));
    }, [])

    return (
        <>
            <div className='section effectivity-component'>
                <div className='section-header'>
                    <h2>Effectivity</h2>
                    <NewButton partId={part.id} />

                    {/* <div className="search-bar-input">
            <input placeholder="Search" />
            <i className="icon-search"></i>
          </div> */}
                </div>

                {/* <InterchangeabilityList part={part} /> */}

                <div className='effectivity-content' ref={effListRef}>

                    {effList?.length > 0 ? effList.map(eff => <EffectivityItem effListRef={effListRef} effTempId={eff.tempId}/>) :
                        <div className='placeholder-component'>
                            <i>No effectivities configured</i>
                        </div>}
                </div>
            </div>
        </>
    )
}

const nameProp = {
    "tail": "tail_number",
    "line": "line_number",
    "serial": "serial_number",
}

const EffectivityItem = ({ effTempId, effListRef}) => {
    // const [tempRange, setTempRange] = useState(generateMockArray());
    // const [ranges, setRanges] = useState([]);
    const ranges = useSelector(state => selectRanges(state, effTempId));
    // const [isRange, setIsRange] = useState(false);
    const dispatch = useDispatch();


    //
    const eff = useSelector((state) => selectEff(state, effTempId));

    const isRange = eff?.selectionType === "R";
    const editing = useSelector((state) => selectEditingEff(state, effTempId))
    const acTypeDrpdwn = useDropdownConfig(114);
    const rangeDrpdwn = useDropdownConfig(115);
    const [accountParameter, _] = useState([{ "columnName": "accountId", value: localStorage.getItem('u_account_id') }]);
    const { successMsg, infoMsg } = useSnackBar();
    const { errorAlert } = useAlert();

    useEffect(() => {
        if (typeof (eff.aircraftTypeId) === 'number') {
            dispatch(fetchAircrafts({ effTempId, fleetId: eff.aircraftTypeId ?? null }));
        }
    }, [eff.aircraftTypeId])

    const updateAircraft = (acId, selected) => {
        dispatch(udpateAcSelection({ effTempId, acId, selected }))
    }

    const effList = useSelector(selectEffList);

    const aircraftList = useSelector((state) => selectAircrafts(state, effTempId));
    const acByLine = useSelector(state => selectACLine(state, effTempId))
    const acBySerial = useSelector(state => selectACSerial(state, effTempId))

    const saveClick = (closeEdition) => {
        infoMsg("Saving effectivity");
        dispatch(saveEffectivity({
            effTempId,
            closeEdition
        })).then(action => {
            let { effResp } = action.payload;
            if (effResp.data.responseCode === HTTP_RESPONSE_CODES.UPDATED) {
                successMsg("Effectivity Saved");
            } else {
                errorAlert(effResp.message);
            }

        });
    }

    const cancelEditing = () => {


    }

    const startEditing = () => {
        dispatch(startEdition({ effTempId }))
    }

    useEffect(() => {
        if (eff.isNew) {
            effListRef.current?.querySelector("details").setAttribute("open", true);
        }
    }, [])

    let debRanges = useDebounce(ranges, 300);

    useEffect(() => {
        dispatch(applyRanges({ effTempId }))
    }, [debRanges]);

    const handleDeleteEff = () => {
        dispatch(deleteEff({ effTempId })).then(action => {
            let { response } = action.payload;
            if (response.data.responseCode === HTTP_RESPONSE_CODES.DELETED) {
                successMsg("Effectivity deleted");
            }
        })
    }

    const [openStatus, setOpenStatus] = useState(false);

    useEffect(() => {
        if (openStatus === true) {
            dispatch(fetchAcSelection({ effTempId }));
        }
    }, [openStatus]);


    const [view, setView] = useState({ M: "row", R: "row" });


    return (<Expandable2 onOpenChange={(e) => setOpenStatus(e)} summary={
        <>
            
            <>
            </>
            <div className='item-element'>
                <div className='ribbons-container'>
                    {editing && <div className='ribbon'>
                        {LABELS.EDITION_MODE}
                    </div>}
                </div>
                <div className='left'>
                    <span>AC Type/AC Series</span>
                    <b>{eff.aircraftName || "--"}</b>
                </div>

                <div className='right'>
                    {editing ?
                        <MultioptionButton buttons={saveButtons} buttonCallbacks={{
                            'save': () => saveClick(true),
                            'save-continue': () => saveClick(false),
                            'cancel': () => cancelEditing()
                        }}></MultioptionButton>
                        :
                        <i onClick={() => startEditing()} className='icon-edit'></i>
                    }
                    {
                        typeof (eff.id) === 'number' ?
                            <DialogTrigger dialogContent={{ component: DeletePartDialog, props: { item: {}, message: `Are you sure you want to remove effectivity for ${eff.aircraftName}`, onDelete: () => handleDeleteEff() } }}>
                                <i className='icon-delete-new'></i>
                            </DialogTrigger>
                            :
                            <i className='icon-delete-new'></i>
                    }
                    {/* <i className='icon-delete-new'></i> */}
                    {/* <Tag tag={
                    <>

                        <span>Status</span>
                        <b>--</b>
                    </>
                }>
                </Tag> */}


                </div>

            </div>
        </>
    }>
        <div className='expandable-content'>
            <div className='selection'>

                {/* <Input label="AC Type/ AC Series" /> */}
                <Dropdowns filterFn={(opt) => !effList.find(i => i.aircraftTypeId === opt["c.id"]) } disabled={!editing} preSelectValue={eff.aircraftTypeId} onOptionSelect={(accFleet) => dispatch(updateEffectivity({ effTempId, name: "aircraftTypeId", value: accFleet["c.id"], obj: accFleet }))} selectionLabel="name" optionLabel="name" data={acTypeDrpdwn.config} parameters={accountParameter} />
                <Radios disabled={!editing} onChange={(newV) => { dispatch(updateEffectivity({ effTempId, name: "selectionType", value: Boolean(newV === "true") ? "R" : "M" })) }} value={isRange} name="fixed" items={[{ value: false, label: "Manual Selection" }, { value: true, label: "Range Selection" }]} />
            </div>
            {/* {JSON.stringify(eff)} */}
            {isRange ?
                <div className='ranges-selector'>
                    <div className='left-range-s'>
                        {/* <Input label="Range Type" /> */}
                        <Dropdowns disabled={!editing} onOptionSelect={(rangeT) => dispatch(updateEffectivity({ effTempId, name: "rangeType", value: rangeT.id, obj: rangeT }))} preSelectValue={eff.rangeType} data={rangeDrpdwn.config} optionLabel="name" />

                        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>

                            <b>Range(s)</b>
                            {editing && <button onClick={() => dispatch(addRange({ effTempId }))} className='tiny filled' style={{ fontSize: "0.55rem" }}>
                                {/* <i className='icon-add-new' style={{fontSize: "0.2rem"}}></i> */}
                                Add Range
                            </button>}
                        </div>
                        <div className='range-list'>

                            {/* {
                        [1, 2, 3, 4].map((r, i) => <div key={r} className='range'>
                            <b>Range {i + 1}</b>
                            <div>
                                <span>From</span>
                                <Input label="" />
                                <span>To</span>
                                <Input label="" />
                            </div>
                            <i className='icon-delete-new'></i>


                        </div>)
                    } */}
                            {/* {JSON.stringify(ranges)} */}
                            {ranges?.length > 0 ?
                                ranges.map((r, i) => <EffRange disabled={!editing} r={r} i={i} effRangeType={eff.rangeType} effTempId={effTempId} />
                                )
                                :
                                <div className='placeholder-component'>
                                    <i>No ranges configured</i>
                                </div>
                            }
                        </div>

                    </div>
                    <div className='right-range-s'>
                        <div className='right-h'>
                            <b>Selected Aircraft</b>
                            <i onClick={() => setView(prev => ({ ...prev, R: "col" }))} className={`icon-menu rotated ${view.R === "col" ? 'active' : ''}`}></i>
                            <i onClick={() => setView(prev => ({ ...prev, R: "row" }))} className={`icon-menu ${view.R === "row" ? 'active' : ''}`}></i>
                        </div>
                        <div className='array-container'>

                            {/* <div className='array'> */}


                            {typeof (eff.aircraftTypeId) === 'number' ?

                                <div className='array'
                                    style={
                                        view.R === "col" ?
                                        { gridTemplateRows: `repeat(${ Math.ceil(aircraftList.length / 7)}, 1fr)`, gridAutoFlow: 'column', gap:  "0.2rem 0.5rem" }
                                        : {gridTemplateColumns: "repeat(7, 1fr)", gap: "0.5rem 0.2rem"}}
                                        >

                                    {aircraftList.length > 0 ? (
                                        (() => {
                                            switch (eff.rangeType) {
                                                case "tail":
                                                    return aircraftList;
                                                    break;
                                                case "line":
                                                    return acByLine;
                                                    break;
                                                case "serial":
                                                    return acBySerial;
                                                    break;
                                            }
                                        })()
                                    ).map(r =>
                                        <div className={`array-item ${r.selected ? 'active' : ''}`}>
                                            <i className='icon-check-2'></i>
                                            {/* {JSON.stringify(eff.rangeType)} */}
                                            <span>{r[nameProp[eff.rangeType]]}</span>
                                        </div>
                                    ) :
                                        <div className='placeholder-component'>
                                            <i>No aircraft on the selected AC Type/AC Series</i>
                                        </div>
                                    }
                                </div>
                                :
                                <div className='placeholder-component'>
                                    <i>Please select AC Type/AC Series</i>
                                </div>

                            }

                            {/* </div> */}
                        </div>

                    </div>

                </div>
                : <div className='manual-selector'>
                    <div className='right-h'>
                        <b>Selected Aircraft</b>
                        <Input label="" placeholder="Search" />
                        <i onClick={() => setView(prev => ({ ...prev, M: "col" }))} className={`icon-menu rotated ${view.M === "col" ? 'active' : ''}`}></i>
                        <i onClick={() => setView(prev => ({ ...prev, M: "row" }))} className={`icon-menu ${view.M === "row" ? 'active' : ''}`}></i>
                        <div className='all-selectors'>
                            <button onClick={() => { dispatch(selectAll({ effTempId, checked: true })) }} className='outlined small-size iconTextButton selectall'>
                                <Checkbox checked={true} disabled={false} outlined></Checkbox>
                                <b>Select All</b>
                            </button>
                            <button onClick={() => { dispatch(selectAll({ effTempId, checked: false })) }} className='outlined small-size iconTextButton deselectall'>
                                {/* <Checkbox disabled={false} outlined checked={false}></Checkbox> */}
                                <b>Deselect All</b>
                            </button>
                        </div>
                    </div>
                    <div className='range-list'>
                        <div className='array-container'>
                            <i>

                            </i>
                            {typeof (eff.aircraftTypeId) === 'number' ?
                                <div className='array'  
                                style={
                                    view.M === "col" ?
                                    { gridTemplateRows: `repeat(${ Math.ceil(aircraftList.length / 7)}, 1fr)`, gridAutoFlow: 'column', gap:  "0.2rem 0.5rem" }
                                    : {gridTemplateColumns: "repeat(7, 1fr)", gap: "0.5rem 0.2rem"}}
                                >
                                    {aircraftList.length > 0 ?
                                        aircraftList.map((r, j) => <div onClick={(e) => updateAircraft(r.id, !r.selected)} className={`array-item ${r.selected ? 'active' : ''}`}>
                                            <Checkbox disabled={!editing} outlined checked={r.selected} onChange={(newV) => { if (!editing) updateAircraft(r.id, newV) }} />
                                            <span>{r.tail_number}</span>
                                        </div>)
                                        :
                                        <div className='placeholder-component'>
                                            <i>No aircraft on the selected AC Type/AC Series</i>
                                        </div>
                                    }
                                </div>
                                :
                                <div className='placeholder-component'>
                                    <i>Please select AC Type/AC Series</i>
                                </div>

                            }

                            {/* <div className='array'>

                                {}
                            </div> */}
                        </div>
                    </div>
                </div>
            }

        </div>


    </Expandable2>)
}


function generateMockArray() {
    const mockArray = [];
    const groupPattern = [5, 10, 7, 8]; // Modify these numbers to adjust true/false group sizes
    let groupIndex = 0;
    let currentState = true; // Start with true

    for (let i = 0; i < 70; i++) {
        // Generate a random 4-digit number
        const randomNumber = Math.floor(1000 + Math.random() * 9000);
        // Generate a random uppercase letter
        const randomLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));

        mockArray.push({
            serial: `SN${randomNumber}${randomLetter}`,
            active: currentState
        });

        // Check if we've completed the current group's count
        if ((i + 1) % groupPattern[groupIndex] === 0) {
            currentState = !currentState; // Toggle active state
            groupIndex = (groupIndex + 1) % groupPattern.length; // Loop through group pattern
        }
    }

    return mockArray;
}


function getActiveGroups(mockArray) {
    const activeGroups = [];
    let currentGroup = null;

    mockArray.forEach((item, index) => {
        if (item.active) {
            if (!currentGroup) {
                // Start a new group
                currentGroup = { from: item.serial, to: item.serial };
            } else {
                // Update the 'to' field of the current group
                currentGroup.to = item.serial;
            }
        } else if (currentGroup) {
            // End the active group and push it to the result
            activeGroups.push(currentGroup);
            currentGroup = null;
        }
    });

    // Push the last group if it was still active at the end
    if (currentGroup) {
        activeGroups.push(currentGroup);
    }

    return activeGroups;
}


const saveButtons = [
    { label: 'Save and Finish', icon: "icon-save", id: 'save' },
    { label: 'Save and Continue Editing', icon: "icon-save", id: 'save-continue' },
    { label: 'Cancel', icon: "icon-cross", id: 'cancel', type: 'danger' }
];
